<template>
  <VanPopup
    v-model:show="store.showGenerate"
    class="w-[80%] max-w-[400px] max-h-[90%]"
    closeable
    round
  >
    <div class="py-10 w-full flex flex-col justify-center items-center">
      <div>
        <h2 class="text-lg mb-2">{{ t(`story.g.title`) }}</h2>
        <div class="mb-2">
          <button class="mr-2 btn btn-sm btn-primary rounded" @click="checkAll">
            {{ $t("Buttons.selectAll") }}
          </button>
          <button class="btn btn-sm btn-primary rounded" @click="checkReverse">
            {{ $t("Buttons.deselectAll") }}
          </button>
        </div>

        <VanCheckboxGroup
          ref="checkboxGroup"
          v-model="store.generateChecked"
          class="flex flex-col"
        >
          <VanCheckbox
            v-for="item in keys"
            :disabled="item === 'type' || item === store.generateTarget"
            :name="item"
            class="my-1"
          >
            {{ t(`game.base.${item}`) }}
          </VanCheckbox>
        </VanCheckboxGroup>

        <!-- <p class="text-base-content/50 text-xs my-2" v-if="list.length <= 6">
          其他内容，完成填写后可以选择参考
        </p> -->

        <div class="flex items-center my-4 justify-evenly">
          <button class="btn btn-primary" @click="clickAutoGenerate">
            {{ t(`story.auto`) }}
          </button>
          <button class="btn" @click="store.showGenerate = false">
            {{ t(`story.g.cancel`) }}
          </button>
        </div>
      </div>
    </div>
  </VanPopup>

  <VanDialog v-model:show="store.showGenerateLoadingModal">
    <div class="flex flex-col gap-4 py-4 px-6">
      <VanField
        v-model="store.generateContent"
        :autosize="{ minHeight: 130, maxHeight: 400 }"
        class="mt-2.5 text-[#ABABAB]"
        rows="1"
        type="textarea"
      />
    </div>

    <template #footer>
      <div class="flex justify-center py-4">
        <div v-if="store.isGenerating" class="flex items-center">
          <VanLoading class="mr-3" color="#fff" />
          <button class="btn btn-sm" @click="clickStop">
            {{ $t("Buttons.stop") }}
          </button>
        </div>
        <template v-else>
          <button class="btn btn-primary btn-sm mr-2" @click="clickInsert">
            {{ $t("Buttons.insert") }}
          </button>

          <button
            class="btn btn-sm"
            @click="store.showGenerateLoadingModal = false"
          >
            {{ t(`story.g.cancel`) }}
          </button>
        </template>
      </div>
    </template>
  </VanDialog>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { ref } from "vue";
import { CheckboxGroupInstance } from "vant/es";
import { useGlobalStream } from "@/stores/globalStream";
import { useGalGameEditor } from "@/stores/galGameEditor";
import { ApiPostGalGameComplete } from "@/apis/gal-game";
import i18n from "@/locales";

const { t } = useI18n();
const store = useGalGameEditor();
const checkboxGroup = ref<CheckboxGroupInstance | null>(null);

const keys: Array<GalGameParams> = [
  "type",
  "name",
  "description",
  "characterzz",
  "player",
];

const clickAutoGenerate = async () => {
  const { form, generateChecked, generateTarget } = store;
  const params: GalGame = {} as GalGame;
  generateChecked.map((v) => {
    // @ts-ignore
    params[v] = JSON.parse(JSON.stringify(form[v]));
  });
  if (generateTarget === "characterzz") {
    const character = params.characterzz.find(
      (v) => v.id === store.activeCharacterId
    );
    character!.introduction += `"""${i18n.global.t(
      "Texts.completeContent"
    )}"""`;
  } else if (generateTarget === "player") {
    params.player.introduction += `"""${i18n.global.t(
      "Texts.completeContent"
    )}"""`;
  } else if (generateTarget === "description") {
    params[generateTarget] += `"""${i18n.global.t("Texts.completeContent")}"""`;
  }
  store.showGenerate = false;
  store.showGenerateLoadingModal = true;
  store.isGenerating = true;
  store.generateContent = "";
  try {
    ApiPostGalGameComplete(params as any, callback as any);

    function callback(text: any) {
      if (typeof text === "object") {
        store.generateContent = text.data.text;
        store.isGenerating = false;
      } else store.generateContent += text;
    }
  } catch (e) {
    console.log(e);
  }
};

const clickInsert = () => {
  const { form, generateContent, generateTarget } = store;
  if (generateTarget === "characterzz") {
    const character = form.characterzz.find(
      (v) => v.id === store.activeCharacterId
    );
    character!.introduction += generateContent;
  } else if (generateTarget === "player") {
    form.player.introduction += generateContent;
  } else if (generateTarget === "description") {
    form.description += generateContent;
  } else if (generateTarget === "node") {
    const { activeNode } = store;
    activeNode.description += generateContent;
    store.saveNode();
    if (activeNode.type === 3 && activeNode.dialogzzCount === 0)
      store.addDialog(4, activeNode.description);
  }
  if (generateTarget !== "node") store.saveBase();

  store.showGenerateLoadingModal = false;
};

const clickStop = () => {
  useGlobalStream().stopStream();
  store.isGenerating = false;
};

const checkAll = () => {
  checkboxGroup.value!.toggleAll(true);
};

const checkReverse = () => {
  checkboxGroup.value!.toggleAll({ checked: false, skipDisabled: true });
};
</script>
